export enum Environments {
  PRODUCTION = "production",
  PREVIEW = "preview",
  DEV = "localhost",
  AUTOMATION = "automation",
}
